/**
 * Types and constants for the resizable state (schema browser and editor browser).
 */

export const DEFAULT_SCHEMA_BROWSER_WIDTH = 288;
export const DEFAULT_EDITOR_BROWSER_WIDTH = 230;
export const MIN_SCHEMA_BROWSER_WIDTH = 230;
export const MAX_SCHEMA_BROWSER_WIDTH = 600;
export const MIN_EDITOR_BROWSER_WIDTH = 230;
export const MAX_EDITOR_BROWSER_WIDTH = 600;

export interface ResizableState {
  schemaBrowserWidth: number;
  editorBrowserWidth: number;
  isResizingSchemaBrowser: boolean;
  isResizingEditorBrowser: boolean;
}

export const DEFAULT_RESIZABLE_STATE: ResizableState = {
  schemaBrowserWidth: DEFAULT_SCHEMA_BROWSER_WIDTH,
  editorBrowserWidth: DEFAULT_EDITOR_BROWSER_WIDTH,
  isResizingSchemaBrowser: false,
  isResizingEditorBrowser: false,
};
